module.exports = "<p>\n  orders works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/orders/orders.component.html
// module id = ./src/app/components/account/orders/orders.component.html
// module chunks = main